import React from 'react';

const CopyrightText: React.FC = () => {
    return (
      <div className="CopyrightText">
          <p>Copyright {new Date().getFullYear()} LAMA, LLC.</p>
      </div>
    );
  }
  
  export default CopyrightText;